import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Form, Input, message, Alert } from 'antd';
import { DRAFT_IS_SAVED, SAVE_DRAFT } from '../../state/lease_contract/types';
import { RESOURCE } from '../../config/constants/alerts';
import ModalComponent from '../../components/modals/ModalComponent';
import { STATUS } from '../../config/constants/states';
import Schema from '../../classes/index';
import PropTypes from 'prop-types';

const SaveDraftContract = ({ previewData, saveDraft, isSaved, resetStatus, sourceUrl }) => {

  const [form] = Form.useForm();
  const [modalVisible, setModalVisible] = useState(false);

  const saveContract = async (email) => {
    saveDraft(await Schema.rentContract.draft({
      ...previewData,
      ...email,
      sourceUrl: sourceUrl
    }));
  };

  useEffect(() => {
    if (isSaved === STATUS.SUCCESS) {
      setModalVisible(false);
      resetStatus();
      message.success('Borrador guardado satisfactoriamente');
    } else if (isSaved === STATUS.ERROR) {
      message.error('Ha ocurrido un error al intentar guardar su borrador');
      setModalVisible(false);
      resetStatus();
    }
  }, [isSaved]);

  const FormContent = () => (
    <>
      <Form
        form={form}
        layout="vertical"
        autoComplete="on"
      >
        <Form.Item
          label="Ingresa tu email y te enviaremos un link para que puedas continuar creando tu contrato en otro momento."
          name={'email'}
          rules={[
            {
              required: true,
              pattern: new RegExp(/^\S+@\S+\.\S+$/),
              message: 'Debes ingresar un correo válido'
            }
          ]}
        >
          <Input size="large" autoComplete="off" />
        </Form.Item>
      </Form>
      <Alert
        message="Nota"
        description="Esta acción guardará provisoriamente la información ingresada en los campos del formulario. Las imagenes y/o 
                documentos cargados hasta el momento no serán respaldados."
        type="warning"
        showIcon
      />
    </>
  );

  return (
    <ModalComponent
      modalVisible={modalVisible}
      spinning={false}
      title='Guarda tu avance y continúa en otro momento'
      okText='Guardar borrador'
      cancelText='Cancelar'
      buttonOnClick={() => setModalVisible(true)}
      onCancel={() => setModalVisible(false)}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            saveContract(values);
          });
      }}
      buttonSize="large"
      type="dashed"
      buttonLabel='Guardar'
      content={<FormContent />}
    />
  );
};

SaveDraftContract.propTypes = {
  previewData: PropTypes.object.isRequired,
  saveDraft: PropTypes.func.isRequired,
  isSaved: PropTypes.string.isRequired,
  resetStatus: PropTypes.func.isRequired,
  sourceUrl: PropTypes.string,
};

const data = (state) => ({
  previewData: state.contract.previewData,
  isSaved: state.contract.isSaved,
  sourceUrl: state.contract.sourceUrl
});

const actions = (dispatch) => ({
  saveDraft: (data) => dispatch({ type: SAVE_DRAFT, payload: { ...data, resource: RESOURCE.SAVE_DRAFT } }),
  resetStatus: () => dispatch({ type: DRAFT_IS_SAVED, payload: STATUS.PENDING }),
});

export default connect(data, actions)(SaveDraftContract);